// Add nofollow only to account.luxeolshop.com links
window.addEventListener('load', function() {
  const links = document.querySelectorAll('a[href]');
  
  links.forEach(function(link) {
    const href = link.getAttribute('href');
    
    // Check if link contains account.luxeolshop.com
    if (href && href.includes('account.luxeolshop.com')) {
      link.setAttribute('rel', 'nofollow noreferrer noopener');
      console.log('Added nofollow to account link:', href); // For debugging
    }
  });
});
